export default __webpack_public_path__ + "locales/tr/ChangePhoneDialog.json?hash=22ab299b81dfddb45ed94b1820d7f28c";